import api from "../../instance/api";
import {
  errorUpdate,
  errorUserData,
  startUpdate,
  startUserData,
  successUpdate,
  successUserData,
} from "../../slice/Profile";

const getUserProfile = (type) => async (dispatch) => {
  dispatch(startUserData());

  try {
    const res = await api.get(`/counsellor`);
    dispatch(successUserData(res.data));
  } catch (err) {
    dispatch(errorUserData(err?.response?.data?.message));
  }
};

const updateProfile = (userData) => async (dispatch) => {
  let cid = localStorage.getItem("cid");
  dispatch(startUpdate());

  try {
    const res = await api.patch(`/counsellor/${cid}`, userData);
    dispatch(successUpdate(res.data));
  } catch (err) {
    dispatch(errorUpdate(err?.response?.data));
  }
};

export { getUserProfile, updateProfile };
